"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxemitter_1 = require("./rxemitter");
function RxOn(a, b, c) {
    if (b === void 0) { b = false; }
    if (c === void 0) { c = null; }
    var eventObj = typeof a == 'object' ? a : { eventName: a, unsubscribe: b, target: c };
    return function (target, name) {
        var eventName = eventObj.name || eventObj.event || eventObj.eventName;
        Object.defineProperty(target, name, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: rxemitter_1.RxEmitter.on(eventName, eventObj.target)
        });
    };
}
exports.RxOn = RxOn;
//# sourceMappingURL=rxon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxemitter/rxon.js
// module id = 1311
// module chunks = 0